<template>
  <button
      :class="{box1: isactive, box2: !isactive}"
      value="this.currentValue"
      :disabled="disabled"
      @click="previousStep">
    <div :class="{texttitle1: isactive, 'texttitle2': !isactive}">
      {{ buttontext }}
    </div>
  </button>
</template>
<script>
export default {
  name: "StepFlowButton",
  props: {
    currentValue: {
      type: Number,
      required: true,
    },
    isactive: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttontext: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    previousStep() {
      this.$emit("go-back", this.currentValue);
    },
  },
};
</script>

<style>
.texttitle1 {
  font-family: "Equip";
  font-style: normal;
  font-weight: inherit;
  font-size: 16px;
  line-height: 30px;
  color: #424242;
  margin: 0 !important;
}
.texttitle2 {
  font-family: "Equip";
  font-style: normal;
  font-weight: inherit;
  font-size: 16px;
  line-height: 30px;
  color: #6e6e6e;
  margin: 0 !important;
}
.box1 {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;
  margin-bottom: 8px;
  width: 100%;
  height: 72px;
  background: #eff8fc;
  border: 2px solid #1998d5;
  border-radius: 4px;
  flex: none;
  order: 1;
  flex-grow: 0;
}
.box2 {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;
  margin-bottom: 8px;
  width: 100%;
  height: 72px;
  background: #ffffff;
  border: 1px solid #dee5ec;
  border-radius: 4px;
  flex: none;
  order: 1;
  flex-grow: 0;
}
</style>
